import React, { useEffect, useState } from 'react';
import style from './loader.module.scss';

type Props = {};
const ContentLoader = () => {
  return (
    <div className={style.container}>
      <div className={style.loader}>
        <div />
      </div>
      Loading
    </div>
  );
};
export default ContentLoader;
